import React from 'react';
import Layout from '../molecules/Layout/Layout';

const withLayout = (Component) => (props) => (
  <Layout>
    <Component {...props} />
  </Layout>
);

export default withLayout;
